import { Component, OnDestroy, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, of, Subscription } from 'rxjs';
import { Logistiques } from '../../logistiques';
import { LogistiquesService } from '../../logistiques.service';

@Component({
  selector: 'app-encadreurs-update',
  templateUrl: './encadreurs-update.component.html',
  styleUrls: ['./encadreurs-update.component.css']
})
export class EncadreursUpdateComponent implements OnInit, OnDestroy {
  user = JSON.parse(localStorage.getItem('user'));
  subscription: Subscription = new Subscription();
  @Input() id: string;
  e: Logistiques;
  public form: FormGroup;
  submitted = false;
  errorMsg = '';
  roles = ['chauffeur', 'convoyeur', 'cantinier', 'maitre', 'entraineur'];
  errorLoading = '';
  loading = true;

  constructor(
    private service: LogistiquesService,
    private modal: NgbModal,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.getEncadreur(this.id);
    this.createForm();
  }

  getEncadreur(id: string): void {
    this.subscription.add(
      this.service.view('encadreurs', id)
        .subscribe(arg => {
          this.e = arg;
          this.loading = false;
        },
          erg => {
            this.errorMsg = erg;
            this.loading = false;
          })
    );
  }

  open(c: any): void {
    this.modal.open(c);
  }

  createForm(): void {
    this.form = this.fb.group({
      encadreur: ['', Validators.required],
      mobile: ['', Validators.required],
      role: ['', Validators.required],
      pin: ['', Validators.required],
      piece: ['']

    });
  }

  onSubmit(): void {
    this.submitted = true;
    this.subscription.add(
      this.service.update('encadreurs', this.id, this.form.value)
        .subscribe(
          arg => {
            this.getEncadreur(this.id);
            this.submitted = false;
            this.modal.dismissAll();
          },
          erg => {
            this.errorMsg = erg;
            this.submitted = false;
          })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
